/**
* Vue Router
*
* @library
*
* https://router.vuejs.org/en/
*/

// Lib imports
import Router from 'vue-router'
import Meta from 'vue-meta'
import globals from './../globals'

export default {
  install: (app, { paths, defaultViews, theme, extendRouterUserHasRole, extendRouterBeforeEach, callback }) => {
    var i = 0
    const localApp = new app({})

    if (defaultViews === true) {
      const views = require('./default-paths.js').default

      views.forEach((p, i) => {
        if (!paths.some(o => o.view === p.view)) {
          p.props = {}
          if (theme.logo) { p.props.logoImage = theme.logo }
          if (theme.background) { p.props.backgroundImage = theme.background }
          paths.push(p)
        }
      })

      paths.forEach((p, i) => {
        if (!p) { return }

        if (defaultViews[p.view]) {
          p.props = defaultViews[p.view]
        }
      })

      paths = paths.filter(p => !!p)
    }

    let home = paths.find(p => p.home === true)
    home = home ? home.path : '/dashboard'

    app.use(Router)

    const router = new Router({
      mode: 'history',
      routes: route(paths),
      scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        }
        if (to.hash) {
          return { selector: to.hash }
        }
        return { x: 0, y: 0 }
      }
    })

    app.use(Meta)

    router.afterEach((to, from) => {
      // Remove initial splash screen
      const splashScreen = document.querySelector('.app-splash-screen')
      if (splashScreen) {
        splashScreen.style.opacity = 0
        setTimeout(
          () =>
            splashScreen &&
            splashScreen.parentNode.removeChild(splashScreen),
          300
        )
      }

      // On small screens collapse sidenav
      if (
        window.layoutHelpers &&
        window.layoutHelpers.isSmallScreen() &&
        !window.layoutHelpers.isCollapsed()
      ) {
        setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
      }

      // Scroll to top of the page
      globals().scrollTop(0, 0)
    })

    router.beforeEach((to, from, next, savedPosition) => {
      // Set loading state
      document.body.classList.add('app-loading')
      const user = localStorage.getItem('user')
      if (!to.meta.anonymousAuth) {
        if (!user) {
          localApp.$api.UI.ShowError('Erro', 'Não autenticado')
          return next({ path: '/' })
        } else {
          const dataExpiracao = new Date(JSON.parse(user).expiresAt)
          const dataAtual = new Date()

          if (dataAtual > dataExpiracao || !userHasPermission(to, from, next)) {
            return localApp.$api.UTIL.Auth.Logout(true)
          }
        }
      } else {
        if (user && router.extendRouterBeforeEach(localApp, to, from, next)) { return next({ path: home }) }
      }

      // Add tiny timeout to finish page transition
      setTimeout(() => next(), 10)
    })

    router.goToHome = (path) => {
      if (path !== home) router.push(home)
    }

    router.extendRouterBeforeEach = extendRouterBeforeEach || (() => true)

    router.extendRouterUserHasRole = extendRouterUserHasRole || (() => true)

    router.altPush = (...args) => {
      window.programmaticRouter = true
      router.push(...args)
    }

    router.userHasPermission = userHasPermission
    router.userHasRole = userHasRole

    app.prototype.router = router
    function route (paths) {
      var list = []
      for (var i = 0; i < paths.length; i++) {
        list.push(getPath(paths[i]))
      }
      list.push({ path: '*', redirect: home })
      return list
    }

    function getPath (path) {
      i++
      if (!path.breadcrumbs) {
        path.breadcrumbs = [{ text: path.title, icon: path.icon }]
      }

      var item = {
        name: path.view + '_' + i,
        path: path.path,
        alias: path.alias,
        meta: path.meta,
        title: path.title,
        icon: path.icon,
        module: path.module,
        menu: path.menu,
        children: getChildren(path),
        component: view(path),
        props: path.props
      }

      item.meta.title = path.title
      item.meta.breadcrumbs = path.breadcrumbs
      item.meta.dir = path.dir

      return item
    }

    function view (path) {
      if (path.view) {
        if (path.module) {
          return path.module
        } else if (path.default) {
          return function (resolve) {
            require([`../../views/${path.view}.vue`], resolve)
          }
        } else {
          return function (resolve) {
            require([`@/${path.dir}${path.view}.vue`], resolve)
          }
        }
      } if (path.component) { return path.component } else {
        return function (resolve) {
          require(['../../views/emptyview.vue'], resolve)
        }
      }
    }

    function getChildren (path) {
      if (path.items) {
        var list = []
        for (var i = 0; i < path.items.length; i++) {
          var item = path.items[i]

          const itemDir = item.dir
          if (item.parentDir) {
            if (item.dir && item.items && item.items.length > 0) {
              item.items.forEach(function (p) { return (p.parentDir = itemDir) })
            }
            item.dir = path.dir + item.parentDir
          } else {
            item.dir = path.dir
          }
          if (itemDir) { item.dir += itemDir }

          item.path = path.path + item.path

          item.breadcrumbs = []
          if (path.breadcrumbs) {
            path.breadcrumbs.forEach(p => item.breadcrumbs.push(p))
          } else {
            item.breadcrumbs.push({ text: path.title, icon: path.icon })
          }
          item.breadcrumbs.push({ text: item.title, icon: item.icon })

          list.push(getPath(item))
        }
        return list
      }
      return null
    }

    function userHasPermission (path, from, next) {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user) {
        const userRoles = []
        const jsonRoles = user.roles

        if (!Array.isArray(jsonRoles)) { userRoles.push(jsonRoles) } else {
          jsonRoles.forEach(e => {
            userRoles.push(e)
          })
        }

        if (!router.extendRouterBeforeEach(localApp, path, from, next)) { return false }

        if (path.meta.allRolesRequired) {
          return path.meta.roles.every(r => userRoles.indexOf(r) >= 0)
        } else if (path.meta.roles) {
          return path.meta.roles.some(r => userRoles.indexOf(r) >= 0)
        } else { return true }
      } else {
        return localApp.$api.UTIL.Auth.Logout(true)
      }
    }

    callback(router)

    function userHasRole (role) {
      if (role && Array.isArray(role)) {
        return role.some(p => userHasRole(p))
      }

      const extendFn = router.extendRouterUserHasRole(localApp, role)
      if (extendFn.stop) { return extendFn.result } else if (!extendFn) { return false }

      const user = JSON.parse(localStorage.getItem('user'))
      if (user) {
        const userRoles = []
        const jsonRoles = user.roles

        if (!Array.isArray(jsonRoles)) { 
          userRoles.push(jsonRoles) 
        } else {
          jsonRoles.forEach(e => {
            userRoles.push(e)
          })
        }
        
        return userRoles.indexOf((process.env.VUE_APP_PREFIX_ROLE) + role) >= 0
      }

      return false
    }
  }
}
